import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/tr'

dayjs.extend(relativeTime)
dayjs.locale('tr')

export function useFormatters() {
  const formatDate = (date: string | Date | null, format = 'DD MMMM YYYY'): string => {
    if (!date) return '-'
    return dayjs(date).format(format)
  }

  const formatDateTime = (date: string | Date | null, format = 'DD MMMM YYYY HH:mm'): string => {
    if (!date) return '-'
    return dayjs(date).format(format)
  }

  const formatCurrency = (amount: number, currency = 'TRY'): string => {
    const formatted = new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount)
    return formatted
  }

  const formatNumber = (value: number, decimals = 2): string => {
    return new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value)
  }

  const formatFullName = (firstName: string, lastName: string): string => {
    return `${firstName} ${lastName}`.trim()
  }

  const formatPhone = (phone: string): string => {
    const cleaned = phone.replace(/\D/g, '')
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
    }
    return phone
  }

  const formatShortDate = (date: string | Date | null): string => {
    if (!date) return '-'
    return dayjs(date).format('DD MMM')
  }

  /** Tablolar için kısa ISO tarih (YYYY-MM-DD) */
  const formatTableDate = (date: string | Date | null | undefined): string => {
    if (date == null || date === '') return '—'
    const x = dayjs(date)
    return x.isValid() ? x.format('YYYY-MM-DD') : String(date).slice(0, 10)
  }

  const getInitials = (firstName: string, lastName: string): string => {
    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
  }

  const formatRelativeTime = (date: string | Date): string => {
    return dayjs(date).fromNow()
  }

  const getDaysDifference = (startDate: string | Date, endDate: string | Date): number => {
    return dayjs(endDate).diff(dayjs(startDate), 'day')
  }

  return {
    formatDate,
    formatDateTime,
    formatCurrency,
    formatNumber,
    formatFullName,
    formatPhone,
    formatShortDate,
    formatTableDate,
    getInitials,
    formatRelativeTime,
    getDaysDifference
  }
}
